<div style="padding: 40px;">
	<h3 style="color: grey;">Educación Formal</h3>
	<div class="search-container">
	  <input
		type="text"
		placeholder="Buscar por nombre de materia"
		(input)="filterCardsByName($event.target.value)"
		class="search-input"
	  />
	</div>
  
	<div class="col-lg-12 control-section card-control-section reveal_card_layout">
	  <div class="e-sample-resize-container e-card-resize-container">
		<div class="row">
		  <div *ngFor="let card of filteredCards; let i = index" class="col-md-3 mb-4">
  
			<div class="event-card"
			[style.backgroundImage]="'url(' + (card.M14FOR && card.M14FOR !== '' ? 'data:image/png;base64,' + card.M14FOR : 'assets/images/login/default-materia-v1.png') + ')'">
  
			  <!-- Badge prematriculada -->
			  <div *ngIf="card.PREMATRICULADA == 'S'" class="hs-enrolled-badge" role="status" aria-label="Matriculado">
				<i class="fa-solid fa-circle-check" aria-hidden="true"></i>
				<span class="hs-enrolled-text">INSCRITO A MATERIA</span>
			  </div>
  
			  <!-- Overlay degradado -->
			  <div class="event-card-overlay">
				<div class="event-card-body">
				  <p class="event-card-title" style="font-size:15px !important">{{card.M11DES}}</p>
				  <p class="event-card-title chip">MATERIA NORMAL / GENERAL</p>
				  <p class="event-card-meta" style="font-size:13px !important">
					<strong>{{card.M11COD}}</strong> &nbsp;|&nbsp; Créd. {{card.M11CRED}} &nbsp;|&nbsp; Nivel: {{card.M14NIV}}
				  </p>
				  <p *ngIf="this.cliente != 'cuc'" class="event-card-hours" style="font-size:13px !important">
					<i class="fa-regular fa-clock"></i> {{card.M11CRED * 18}} hrs
				  </p>
				  <div class="event-card-actions">
					<button class="event-btn"
							(click)="gruposAutorizados(card.M11COD, card.FAC59COD, card.M12CAR, i)">
						<i class="fa fa-calendar-days" style="margin-right:5px;color: #10a560;"></i> 
						<span *ngIf="this.cliente != 'cuc'">Inscribir</span>
						<span *ngIf="this.cliente == 'cuc'">Prematricular</span>
					</button>
					<button class="event-btn"
							(click)="toggleSidebarInfo(i)">
					  <i class="fa fa-circle-info" style="margin-right:5px;color: #c0b367;"></i> Información
					</button>
				  </div>
				</div>
			  </div>
			</div>
			<!-- FIN CARD -->
  
			<!-- Panel Flotante Grupos -->
			<div class="sidebar" [ngClass]="{'open': selectedCardIndex === i}">
			  <div class="sidebar-content">
				<div style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: fixed; top: 0; left: 0; right: 0; background-color: #fafafa; padding: 10px; z-index: 1000;">
				  <h5>{{card.M11DES}}</h5>
				  <button class="e-btn e-outline e-primary" (click)="toggleSidebar(i)">
					Cerrar
				  </button>
				</div>
				<br><br>
				<div class="row">
				  <div style="margin-bottom: 4px;" class="col-6 col-sm-6 col-md-4 col-lg-6" *ngFor="let grupo of grupos">
					<div tabindex="0" class="e-card">
					  <div class="e-card-header">
						<div class="row col-lg-12">
						  <div class="col-md-3">
							<div *ngIf="grupo.IMAGEN == ''" style="width: 50px; height: 50px; border-radius: 50%; background-color: #f0f0f0; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
							  <i class="fa-solid fa-user fa-2x" style="color: grey;"></i>
							</div>
							<img *ngIf="grupo.IMAGEN !== ''" [src]="grupo.IMAGEN" alt="Avatar" style="width: 50px; height: 50px; border-radius: 50%; margin: 0 auto;">
						  </div>
						  <div class="col-md-9">
							<div class="e-card-header-caption" style="font-size: 12px;">
							  <div class="e-card-sub-title" style="font-size: 13px;font-weight: bold;color:grey">{{grupo.M11DES}}</div>
							  <div class="e-card-sub-title" style="font-size: 13px;font-weight: bold;color:grey">{{grupo.M44MAT != '' ? grupo.M44MAT : grupo.M11COD}}</div>
							  <div class="e-card-sub-title" style="font-size: 13px;font-weight: bold;color:grey">Grupo # {{grupo.M23GRU}} - {{grupo.E05DES}}</div>
							  <div *ngIf="this.cliente != 'cuc'" class="e-card-sub-title" style="font-size: 12px;font-weight: bold;color:red">Cupo: {{grupo.CUPO}}</div>
							  <div class="e-card-header-title" style="font-size: 12px;">{{grupo.M26NOM == '' ? 'No Disponible' : grupo.M26NOM}}</div>
							  <div class="e-card-sub-title" style="font-size: 12px;">Sede: {{grupo.M05DES}}</div>
							  <div style="font-size: 12px;">Horarios:</div>
							  <div style="color:grey;font-size: 11px;" [innerHTML]="grupo.HORARIO"></div>
							  <br>
							  <div *ngIf="grupo.PREMATRICULADA == 'S' && card.PREMATRICULADA == 'S'"
								   (click)="eliminarPrematricula(grupo.M11COD, grupo.E43MAT, grupo.M44MAT, grupo.M11GEN, grupo.M23GRU, i, grupo.EQUIVALENTE)">
								<i class="fa fa-circle-minus fa-2x" style="color: red;"></i> <strong style="color: red;"> DESINSCRIBIR</strong>
							  </div>
							  <div *ngIf="grupo.PREMATRICULADA == 'N' && card.PREMATRICULADA == 'N'"
								   (click)="prematricula(grupo.M11COD, grupo.M23GRU, grupo.M44MAT, grupo.EQUIVALENTE, i, grupo.M11GEN)">
								<i class="fa fa-circle-plus fa-2x" style="color: green;"></i> 
								<!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
								<strong *ngIf="this.cliente == 'cuc'" style="color: var(--app-primario, #317ab9);"> PREMATRICULAR</strong>
								<strong *ngIf="this.cliente != 'cuc'" style="color: var(--app-primario, #317ab9);"> INSCRIBIR</strong>
							  </div>
							</div>
						  </div>
						</div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</div>
  
			<!-- Panel Flotante Información -->
			<div class="sidebar" [ngClass]="{'open': selectedCardIndexInfo === i}">
			  <div class="sidebar-content">
				<div style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: fixed; top: 0; left: 0; right: 0; padding: 10px; z-index: 1000;">
				  <h5>{{card.M11DES}}</h5>
				  <button class="e-btn e-outline e-primary" (click)="toggleSidebarInfo(i)">
					Cerrar
				  </button>
				</div>
				<br><br>
				<div class="row">
				  <div style="margin-bottom: 4px;" class="col-6 col-sm-6 col-md-4 col-lg-6">
					<div style="width: 100%; font-weight: bold;font-size: 11px;text-align: left;margin-bottom: -8px;">INFORMACIÓN MATERIA</div>
					<br>
					<div class="contenidoInfo">
					  <div [innerHTML]="card.M11INF"></div>
					</div>
				  </div>
				  <div style="margin-bottom: 4px;" class="col-6 col-sm-6 col-md-4 col-lg-6">
					<div style="width: 100%; font-weight: bold;font-size: 11px;text-align: left;margin-bottom: -8px;">OBJETIVOS MATERIA</div>
					<br>
					<div class="contenidoInfo">
					  <div class="contenidoInfo">
						<div [innerHTML]="card.M11OBJ"></div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</div>
  
			<!-- Panel Flotante Calendar -->
			<div class="sidebar" [ngClass]="{'open': selectedCardIndexCalendar === -1}">
			  <div class="sidebar-content">
				<div style="width: 100%; display: flex; justify-content: space-between; align-items: center; position: fixed; top: 0; left: 0; right: 0; padding: 10px; z-index: 1000;">
				  <h5>Calendario Estudiantil</h5>
				  <button class="e-btn e-outline e-primary" (click)="toggleSidebarCalendar(-1)">
					Cerrar
				  </button>
				</div>
				<br><br>
				<ejs-schedule width='100%' height='550px' [selectedDate]="selectedDate" [eventSettings]="eventSettings">
				  <e-views>
					<e-view option="Week" startHour="07:00" endHour="15:00"></e-view>
					<e-view option="WorkWeek" startHour="10:00" endHour="18:00"></e-view>
					<e-view option="Month" [showWeekend]="showWeekend"></e-view>
				  </e-views>
				</ejs-schedule>
			  </div>
			</div>
  
		  </div>
		</div>
	  </div>
	</div>
  </div>